import * as angular from 'angular';

import { ContextualField, Identifier, Group, SelectionStrategy, IdentifierType, IValueViewModel, ObjectType } from '../../../../models/index';
import * as Fields from '../../../../common/helpers/contextual';
import { getCommonProperties } from './commonProperties';
import { linkedGuidProperty } from './linkedGuidProperty';
import { tagDefinitionGuidProperty } from './tagDefinitionGuidProperty';
import { configureVariableTypeProperties, variableProperties } from '../../../../common/helpers/contextual';

const selectionStrategyProperty = angular.copy(Fields.SelectionStrategy);
const valueTypeProperty = angular.copy(Fields.ValueType);
const validatedProperties: ContextualField[] =
    getCommonProperties()
        .concat([
            selectionStrategyProperty,
            linkedGuidProperty,
            tagDefinitionGuidProperty,
            valueTypeProperty
        ])
        .concat(variableProperties);

export function getValidatedProperties(selectedItem: Identifier, group: Group): ContextualField[] {
    const properties = validatedProperties;

    showHideProperties(selectedItem.selectionStrategy);
    selectionStrategyProperty.onChange = value => {
        showHideProperties(value);
    };

    tagDefinitionGuidProperty.extraData.filter = (list: IValueViewModel[]) => list
        .filter(l => l.objectType === ObjectType.Tag);
    linkedGuidProperty.extraData.filter = (list: IValueViewModel[]) => list.filter(l =>
        l.objectType === ObjectType.Identifier && l.identifierType === IdentifierType.CalculatedValue
    );

    configureVariableTypeProperties(properties, selectedItem);
    return properties;
}

function showHideProperties(value: SelectionStrategy) {
    valueTypeProperty.extraData.selectionStrategy = value;
    valueTypeProperty.hide = value === SelectionStrategy.Children;
    linkedGuidProperty.hide = value !== SelectionStrategy.Calculated;
    tagDefinitionGuidProperty.hide = value !== SelectionStrategy.Tags;
    variableProperties.forEach(v => v.hide = value !== SelectionStrategy.Children);
}